import { map, mergeMap, catchError } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { financialService } from '../../../common/services';
import * as actionTypes from './actionTypes';
import * as financialActions from './actions';

export function fetchFinancialInfo(action$) {
  return action$.pipe(
    ofType(actionTypes.FETCH_FINANCIALINFO),
    mergeMap(({ payload }) => {
      return financialService.getFinancialInfo(payload)
        .pipe(
          map(res => financialActions.fetchFinancialInfoSuccess(res.responceObject.records)),
          catchError(error => {
            console.log(error)
          })
        )
    })
  )
}